<i class="fas fa-eye" (click)="viewAll()"></i>

<ol>
  <li></li>
  <ng-container *ngFor="let item of itemsOfIterest; index as i">
    <li (click)="view(item)" [class.clickable]="item.canView && item.documentIdentifier"
      [class.disabled]="!item.canView" [matTooltip]='item.tooltip'
      [matTooltipClass]="'multiLineTooltip'" [matTooltipPosition]="i % 2 == 0 ? 'above' :  'below'"
      [class]="item.class">
    </li>
  </ng-container>
  <li></li>
</ol>

<ng-template #itemView let-data>
  <div mat-dialog-content>
    <mat-tab-group>
      <mat-tab label="{{'Case.Timeline.Events' | translate}}">
        <ng-container [ngTemplateOutlet]="eventsTable"
          [ngTemplateOutletContext]="{$implicit: data.executed}"></ng-container>
      </mat-tab>
      <mat-tab label="{{'Case.Timeline.FutureEvents' | translate}}">
        <ng-container [ngTemplateOutlet]="eventsTable"
          [ngTemplateOutletContext]="{$implicit: data.notExecuted}"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-template>

<ng-template #eventsTable let-data>
  <table *ngIf="data?.length else noData" id="eventsTable">
    <tbody>
      <tr *ngFor="let item of data">
        <td>{{ item?.date | date:'dd.MM.yyyy' }}</td>
        <td> {{ item?.text }} </td>
        <td> {{ item?.sentBy }} </td>
        <td>
          <i [ngClass]="{'fa-sms': item.isSms, 'fa-envelope': item.isLetter}"
            [class.cursor-pointer]="item.documentIdentifier && item.canView" class="fas fa-lg" (click)="view(item)"></i>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template #noData>
    <span class="no-data">
      {{'Case.NoData' | translate}}
    </span>
  </ng-template>

</ng-template>